
import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// Admin Dashboard React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
function Basic(props) {
  let [error,setError]=useState('')
  let [id,setID]=useState('')
  let [pass,setPass]=useState('')
  let Submit=()=>{

    if(id=='' || pass==''){
setError('Fill Both Credential')
    }
      let a= {
      id:'Hojouzateadmin'
      ,pass:'Hojouzateadmin'
    }
    var baseString =JSON.stringify(a);
var encodedString = window.btoa( baseString ); // returns "bXktbmFtZS0x"
localStorage.setItem('*Required Cdn',encodedString)

let check=localStorage.getItem('*Required Cdn')
let input={
  id:id
  ,pass:pass
}

var decodedString = window.atob( check );
let store=JSON.parse(decodedString) 

if(store.id==input.id && store.pass==input.pass)
{
window.location.replace('/dashboard')
}
else{
  setError('Wrong Credential')
}
  }
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
           <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput type="Login Id" onChange={(e)=>setID(e.target.value)} label="Login Id" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" onChange={(e)=>setPass(e.target.value)} label="Password" fullWidth />
            </MDBox>
<p style={{color:'red',fontSize:11}}>
         {error}

  </p>          
                <MDBox mt={4} mb={1}>
              <MDButton onClick={()=>Submit()} variant="gradient" color="info" fullWidth>
                sign in
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
